import dragon_welcome from './assets/dragon-welcome.png';
import dragon_proud from './assets/dragon-proud.png';
import dragon_encourage from './assets/dragon-encourage.png';
import dragon_streak5 from './assets/dragon-streak5.png';
import dragon_streak10 from './assets/dragon-streak10.png';
import dragon_goal from './assets/dragon-goal.png';
import fox_welcome from './assets/fox-welcome.png';
import fox_proud from './assets/fox-proud.png';
import fox_encourage from './assets/fox-encourage.png';
import fox_streak5 from './assets/fox-streak5.png';
import fox_streak10 from './assets/fox-streak10.png';
import fox_goal from './assets/fox-goal.png';
import lion_welcome from './assets/lion-welcome.png';
import lion_proud from './assets/lion-proud.png';
import lion_encourage from './assets/lion-encourage.png';
import lion_streak5 from './assets/lion-streak5.png';
import lion_streak10 from './assets/lion-streak10.png';
import lion_goal from './assets/lion-goal.png';
import owl_welcome from './assets/owl-welcome.png';
import owl_proud from './assets/owl-proud.png';
import owl_encourage from './assets/owl-encourage.png';
import owl_streak5 from './assets/owl-streak5.png';
import owl_streak10 from './assets/owl-streak10.png';
import owl_goal from './assets/owl-goal.png';
import companionDragon from './assets/companion-dragon.png';
import companionFox from './assets/companion-fox.png';
import companionLion from './assets/companion-lion.png';
import companionOwl from './assets/companion-owl.png';
import heroAscent from './assets/hero-ascent.jpg';
import contour from './assets/contour.jpg';

export const COMPANION_ART = {
  dragon: { welcome: dragon_welcome, proud: dragon_proud, encourage: dragon_encourage, streak5: dragon_streak5, streak10: dragon_streak10, goal: dragon_goal },
  fox: { welcome: fox_welcome, proud: fox_proud, encourage: fox_encourage, streak5: fox_streak5, streak10: fox_streak10, goal: fox_goal },
  lion: { welcome: lion_welcome, proud: lion_proud, encourage: lion_encourage, streak5: lion_streak5, streak10: lion_streak10, goal: lion_goal },
  owl: { welcome: owl_welcome, proud: owl_proud, encourage: owl_encourage, streak5: owl_streak5, streak10: owl_streak10, goal: owl_goal },
};
export const COMPANION_PORTRAIT = { dragon: companionDragon, fox: companionFox, lion: companionLion, owl: companionOwl };
export const HERO_ASCENT = heroAscent;
export const CONTOUR = contour;
